import { forwardRef } from 'react';

const Control = forwardRef(({ children, className, tag: Tag = 'a', ...props }, ref) => (
	<Tag ref={ref} className={className} {...props}>
		{children}
	</Tag>
));

export default Control;
